<template>
  <div class="product-list-container">
    <nav class="add-navigation flex flex-wrap">
      <div @click="$router.push({name: 'company-admin-recipients'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p style="white-space: nowrap">Back to Recipients</p>
      </div>
      <div class="buttons-wrapper flex-wrap pl-1 ">
        <div @click="$router.push({name: 'company-admin-recipients'})" class="secondary-button my-2 my-md-0">
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="first button-container my-2 my-md-0">
          <primary-button @click.native="addRecipient" class="button">Add Recipient</primary-button>
        </div>
      </div>
    </nav>
    <div class="row p-2 ">
      <div class="col-md-3 col-sm-6 col-12">
        <primary-input
          name="first name"
          :value="recipient.first_name"
          @input="handleNameChange"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('first name')}"
        />
        <div v-if="errors.has('first name')" class="help is-danger">{{ errors.first('first name') }}</div>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <primary-input
          name="last name"
          :value="recipient.last_name"
          @input="handleLastNameChange"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('last name')}"
        />
        <div v-if="errors.has('last name')" class="help is-danger">{{ errors.first('last name') }}</div>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <primary-input
          name="phone number"
          v-model="recipient.phone_number"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('phone number')}"
        />
        <div
          v-if="errors.has('phone number')"
          class="help is-danger"
        >{{ errors.first('phone number') }}</div>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <primary-input
          name="address"
          :value="recipient.address"
          @input="handleAddressChange"
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('address')}"
        />
        <div v-if="errors.has('address')" class="help is-danger">{{ errors.first('address') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton"),
  },
  data: () => ({
    recipient: {
      phone_number: null,
      last_name: null,
      first_name: null,
      address: null,
      number: null,

    },
    msg: null
  }),
  methods: {
    handleNameChange(v) {
      this.recipient.first_name = this.$capitalize(v);
    },
    handleLastNameChange(v) {
      this.recipient.last_name = this.$capitalize(v);
    },
    handleAddressChange(v) {
      this.recipient.address = this.$capitalize(v);
    },
    addRecipient: async function () {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      this.$store
        .dispatch("PostRecipient", this.recipient)
        .then(() => {
          this.$router.push({ name: "company-admin-recipients-list" });
          this.$success("Recipient has been added");
        })
        .catch((err) => {
          if(err.message === 'Request failed with status code 406') {
            this.$snotify.error('Number already exists', {
              timeout: 4000,
            });
          } else {
            if( err.response.data.errors[0].phone_number[0] === "String does not match expected pattern.")

            {
             this.msg = "Please enter a valid phone number for the  phone number_Field."

            }
      /*      else if( err.response.data.errors[0].number === "number 12345678 not in DIDs")
            {
              this.msg =  "number" + " " + `${this.recipient.phone_number}`+ " " + "not in DIDs"
            }*/
            else if( err.response.data.errors[0].phone_number[1] === "String does not match expected pattern."){
              this.msg =  err.response.data.errors[0].phone_number[1] = err.response.data.errors[0].phone_number[0] + " Please enter a valid phone number for the  phone number_Field."
            }

            else  { this.msg = err.response.data.errors}

            this.$snotify.error( this.msg , {
              timeout: 4000,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-list-container {
  padding:0 20px;
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .button-container {
      display: flex;
      justify-content: flex-end;
      flex-direction: row;
      .button {
        height: 40px;
        width: 150px;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 14px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .table {
    margin-top: 20px;
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 90px;
    box-sizing: border-box;
    justify-content: space-between;

    .first {
      min-width: fit-content;
      width: calc(20% - 7.5px);
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .primary-input-container {
      margin-bottom: 20px;
    }
  }
}
@media (max-width: 400px) {
  .text_font_size{
    font-size: 13px;
  }
  .secondary-button{
    width: 150px!important;
  }
}
.row .input{
  margin-bottom: 20px;
}

  .help {
    position: absolute;
    bottom: 3px;
  }
</style>

